import { apiClient } from "@base/api/client";
import type { ReservationsResponse } from "@features/reservation/model/types";

/**
 * GET /82office/resource/api/meeting/reserve?year=&month=
 * 미팅룸 예약 목록 조회 (년/월 기준)
 */
export async function fetchReservations(year: number, month: number): Promise<ReservationsResponse> {
  const { data } = await apiClient.get<ReservationsResponse>("/82office/resource/api/meeting/reserve", {
    params: { year, month },
  });
  return data;
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useQuery } from "@tanstack/react-query";
 * import { fetchReservations } from "@features/reservation/api/reserve";
 *
 * const { data } = useQuery({
 *   queryKey: ["reservations", year, month],
 *   queryFn: () => fetchReservations(year, month),
 * });
 */
